import { Box } from '@chakra-ui/react'

export const PageContent = ({ children, ...rest }: { children: React.ReactNode }) => {
  return (
    <Box sx={{ display: 'grid', gap: 8, placeItems: 'start', justifyItems: 'stretch' }} {...rest}>
      {children}
    </Box>
  )
}
